// extracted by mini-css-extract-plugin
export default {"overlay":"nz-z","bodyOpen":"oz-z","content":"pz-z","header":"qz-z","close":"rz-z","closeNoHeading":"sz-z"};